import logo from "../../assets/gm-logo-name.svg";

const PublicHeader = () => (
  <header className="gm-public-header">
    <div className="gm-public-header-content">
      <img src={logo} alt="Growme" className="gm-public-header-logo" />
    </div>
  </header>
);

export default PublicHeader;
